import React from 'react';

type IIfRuleSectionProps = {
  label: string;
  children: React.ReactNode;
};

const IfRuleSection = ({ label, children }: IIfRuleSectionProps): JSX.Element => (
  <div style={{
    display: 'flex',
    width: '100%',
  }}
  >
    <div style={{
      writingMode: 'vertical-lr',
      textOrientation: 'upright',
      textAlign: 'center',
      backgroundColor: '#150645',
      letterSpacing: '3px',
      fontWeight: 'bolder',
      color: 'white',
      borderRadius: '4px',
    }}
    >
      {label}
    </div>
    <div style={{ width: '100%' }}>
      {children}
    </div>
  </div>
);

export default IfRuleSection;
